module.exports = __webpack_public_path__ + "static/media/dvojita-sipka.464981c6.svg";